import ReactDirective from "acl-ui/angular/reactDirective.umd";
import Pill from "acl-ui/components/Pill";
import ArchivePill from "./archivePill.component";

angular
  .module("acl.visualizer.archivePill", [])
  .component("aclArchivePill", ArchivePill)
  .directive("acluiPill", ReactDirective.getFactory(Pill));
